import DfvAbbreviated from './DfvAbbreviated';

export default DfvAbbreviated;
